import React from 'react';
import { PieChart } from 'lucide-react';

export default function MnoDonutChart({ summary }) {
  const mnoData = summary?.totalSessionsByMno || {
    AIRTEL: 0,
    MTN: 0,
    VODACOM_ZA: 0,
  };

  const colors = {
    AIRTEL: '#F84122',     // CestaSoft Orange
    MTN: '#F59E0B',        // MTN Amber
    VODACOM_ZA: '#0F172A', // Dark Slate
  };

  const labels = {
    AIRTEL: 'Airtel Uganda',
    MTN: 'MTN Uganda',
    VODACOM_ZA: 'Vodacom SA',
  };

  const items = Object.entries(mnoData).map(([key, count]) => ({
    key,
    label: labels[key] || key,
    count: count || 0,
    color: colors[key] || '#94A3B8',
  }));

  const total = items.reduce((sum, item) => sum + item.count, 0) || 1;

  // Donut geometry
  const radius = 58;
  const strokeWidth = 18;
  const circumference = 2 * Math.PI * radius;

  let currentOffset = 0;
  const segments = items.map(item => {
    const percentage = (item.count / total) * 100;
    const strokeDasharray = `${(percentage / 100) * circumference} ${circumference}`;
    const strokeDashoffset = -currentOffset;
    currentOffset += (percentage / 100) * circumference;
    return { ...item, percentage: percentage.toFixed(1), strokeDasharray, strokeDashoffset };
  });

  return (
    <div className="glass-card" style={{ padding: '24px', display: 'flex', flexDirection: 'column', height: '100%', background: '#FFFFFF' }}>
      
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '18px' }}>
        <PieChart size={18} color="#F84122" />
        <h2 style={{ fontSize: '16px', fontWeight: '800', color: '#0F172A', margin: 0 }}>MNO Traffic Share</h2>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, gap: '20px' }}>
        
        {/* SVG Donut */}
        <div style={{ position: 'relative', width: '160px', height: '160px' }}>
          <svg viewBox="0 0 160 160" style={{ transform: 'rotate(-90deg)', width: '100%', height: '100%' }}>
            {/* Background ring */}
            <circle
              cx="80"
              cy="80"
              r={radius}
              fill="none"
              stroke="#F1F5F9"
              strokeWidth={strokeWidth}
            />

            {/* Segments */}
            {segments.map((seg, idx) => (
              <circle
                key={idx}
                cx="80"
                cy="80"
                r={radius}
                fill="none"
                stroke={seg.color}
                strokeWidth={strokeWidth}
                strokeDasharray={seg.strokeDasharray}
                strokeDashoffset={seg.strokeDashoffset}
                strokeLinecap="round"
                style={{ transition: 'stroke-dasharray 0.6s ease' }}
              />
            ))}
          </svg>

          {/* Center Info */}
          <div style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
          }}>
            <span style={{ fontSize: '11px', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: '600' }}>Total</span>
            <span style={{ fontSize: '20px', fontWeight: '800', color: '#0F172A' }}>
              {total > 1 ? total.toLocaleString() : (summary?.totalSessionsInitiated || 0).toLocaleString()}
            </span>
          </div>
        </div>

        {/* Legend List */}
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {items.map((item, idx) => (
            <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: item.color }} />
                <span style={{ color: '#475569', fontWeight: '600' }}>{item.label}</span>
              </div>
              <div>
                <strong style={{ color: '#0F172A', marginRight: '6px' }}>{item.count.toLocaleString()}</strong>
                <span style={{ color: '#64748B', fontSize: '11px' }}>
                  ({((item.count / total) * 100).toFixed(0)}%)
                </span>
              </div>
            </div>
          ))}
        </div>

      </div>

    </div>
  );
}
